import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5fd29695")

_pushScopeId("data-v-5fd29695")
const _hoisted_1 = {
  class: "container popup-container",
  id: "orders-filter"
}
const _hoisted_2 = { class: "orders-filter-title" }
const _hoisted_3 = { class: "filter-block" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { for: "product-select" }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { for: "product-select" }
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { for: "product-select" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { for: "product-select" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { for: "product-select" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "product-select" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { for: "product-select" }
const _hoisted_21 = { class: "position-relative" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { for: "product-select" }
const _hoisted_24 = { class: "position-relative" }
const _hoisted_25 = { class: "filter-block-footer" }
const _hoisted_26 = { class: "second-row-btns" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "middle-hidden-block" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('button.filters')), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('orders.providerName')), 1),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Multiselect, _mergeProps({
              modelValue: _ctx.filter.providerId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.providerId = $event))
            }, _ctx.providersOption, {
              id: 'type-select-' + _ctx.i
            }), null, 16, ["modelValue", "id"]),
            (_ctx.filter.providerId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.providerId = 0))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('ordersFilter.reservationStatus')), 1),
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.filter.status,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.status = $event)),
              valueProp: "id",
              label: "name",
              options: _ctx.orderStatus,
              id: 'type-select-' + _ctx.i,
              "close-on-select": true
            }, null, 8, ["modelValue", "options", "id"]),
            (_ctx.filter.status)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.status = null))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('newOrder.products')), 1),
          _createVNode("div", _hoisted_12, [
            _createVNode(_component_Multiselect, _mergeProps({
              modelValue: _ctx.filter.productId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filter.productId = $event))
            }, _ctx.productsOption, {
              id: 'type-select-' + _ctx.i
            }), null, 16, ["modelValue", "id"]),
            (_ctx.filter.productId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.filter.productId = 0))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('ordersFilter.reservationNumber')), 1),
          _withDirectives(_createVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.orderNumber = $event)),
            class: "bookit-input order-input w100"
          }, null, 512), [
            [_vModelText, _ctx.filter.orderNumber]
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('ordersFilter.reservationDates')), 1),
          _createVNode("div", null, [
            _createVNode(_component_Calendar, {
              ref: "calendar",
              onDateSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dateChanged(_ctx.reservationDateRange))),
              modelValue: _ctx.reservationDateRange.fromDate,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.reservationDateRange.fromDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Calendar, {
              ref: "calendar",
              onDateSelect: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dateChanged(_ctx.reservationDateRange))),
              modelValue: _ctx.reservationDateRange.toDate,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.reservationDateRange.toDate = $event)),
              minDate: _ctx.reservationDateRange.fromDate,
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue", "minDate"])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('ordersFilter.arrivalDates')), 1),
          _createVNode("div", null, [
            _createVNode(_component_Calendar, {
              onDateSelect: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dateChanged(_ctx.arrivalDateRange))),
              modelValue: _ctx.arrivalDateRange.fromDate,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.arrivalDateRange.fromDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Calendar, {
              onDateSelect: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dateChanged(_ctx.arrivalDateRange))),
              modelValue: _ctx.arrivalDateRange.toDate,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.arrivalDateRange.toDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              minDate: _ctx.arrivalDateRange.fromDate
            }, null, 8, ["modelValue", "minDate"])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('product.price-type')), 1),
          _createVNode("div", _hoisted_21, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.filter.priceTypeId,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.filter.priceTypeId = $event)),
              valueProp: "id",
              label: "name",
              options: _ctx.priceTypes,
              id: 'type-select-' + _ctx.i,
              "close-on-select": true
            }, null, 8, ["modelValue", "options", "id"]),
            (_ctx.filter.priceTypeId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.filter.priceTypeId = 0))
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode("div", _hoisted_22, [
          _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('product.channel')), 1),
          _createVNode("div", _hoisted_24, [
            _createVNode(_component_Multiselect, {
              modelValue: _ctx.filter.channelId,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.filter.channelId = $event)),
              valueProp: "id",
              label: "name",
              options: _ctx.channels,
              id: 'type-select-' + _ctx.i,
              "close-on-select": true
            }, null, 8, ["modelValue", "options", "id"]),
            (_ctx.filter.channelId)
              ? (_openBlock(), _createBlock("i", {
                  key: 0,
                  class: "icon-f icon-delete-cross fs-10 multiselect-cross-icon",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.filter.channelId = 0))
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_25, [
        _createVNode("div", null, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.Search && _ctx.Search(...args))),
            class: "search-filter-button"
          }, _toDisplayString(_ctx.$t('button.search')), 1)
        ]),
        _createVNode("div", _hoisted_26, [
          _createVNode("button", {
            type: "button",
            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.Close && _ctx.Close(...args)))
          }, _toDisplayString(_ctx.$t('button.close')), 1),
          _hoisted_27,
          _createVNode("button", {
            type: "button",
            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.ResetFilter && _ctx.ResetFilter(...args)))
          }, _toDisplayString(_ctx.$t('button.clearAll')), 1)
        ])
      ])
    ])
  ]))
})